@import '../../global/utility/responsive/responsive-mixins';
$sizes: 900, 600;

ui-quickfact-group {
  --quickfact-number-columns: 1;

  position: relative;

  @include responsive($sizes);

  display: grid;
  grid-template-columns: repeat(
    var(--quickfact-number-columns, 1),
    minmax(0, 1fr)
  );
  grid-auto-flow: dense;
  gap: 32px;

  > * {
    width: 100%;
    text-align: left;
  }
}

ui-quickfact-group[component-width='600'] {
  --quickfact-number-columns: 2;
}

ui-quickfact-group[component-width='900'] {
  --quickfact-number-columns: 3;
}
